// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".XQyZhzCOgASg3ZmW0FEc{width:310px}.Y7JjzrYiYYpEMtxyLs4C{width:450px!important;max-width:500px!important}.t0KJTkKWZ4y9seI7frS7{color:var(--themePrimary)}.bRMwpdfA8wtWhtXoG4_1{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] .yPhnnbyJXMUYhxfcw4uT{border-radius:4px}@media screen and (max-width:450px){html[dir] .WI53YTvdWUknWNlxdzAs>div{text-align:start}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fixWidthContextMenuAdvanced": "XQyZhzCOgASg3ZmW0FEc",
	"fixWidthContextMenuSuggestion": "Y7JjzrYiYYpEMtxyLs4C",
	"unscheduleText": "t0KJTkKWZ4y9seI7frS7",
	"innerContent": "bRMwpdfA8wtWhtXoG4_1",
	"buttonRadii": "yPhnnbyJXMUYhxfcw4uT",
	"footer": "WI53YTvdWUknWNlxdzAs"
};
module.exports = ___CSS_LOADER_EXPORT___;
